import { makeStyles } from "@material-ui/core/styles";
import { isDarkEnabled } from "../../Common/Utility";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    // backgroundColor: isDarkEnabled() ? "#333644" : ""
    overflow: "hidden"
  },
  alert: {
    color: theme.textAlert,
  },
  button: {
    color: theme.colorScheme,
    cursor: "pointer",
    height: 20,
    width: 20,
  },
  buttons: {
    color: theme.colorScheme,
    cursor: "pointer",
  },
  checkboxColor: {
    color: theme.colorScheme + "!important",
    paddingRight: 0,
    backgroundColor: "transparent",
    "& .MuiSvgIcon-root": {
      fontSize: "0.9rem",
    },
    "& .MuiFormControlLabel-label .MuiSvgIcon-root": {
      fontSize: "1.3rem",
    },
    "& .MuiBadge-badge": {
      fontSize: "0.75rem",
      minWidth: "18px",
      height: "18px",
    },
  },
  "@media (max-width: 430px)": {
    checkboxColor: {
      paddingRight: 0,
    },
  },
  chip: {
    backgroundColor: theme.colorScheme,
    float: "right",
    margin: "2px",
    "&:hover": {
      backgroundColor: theme.colorScheme,
      color: "white",
    },
    "&:focus": {
      backgroundColor: theme.colorScheme,
      color: "white",
    },
  },
  collapse: {
    backgroundColor: isDarkEnabled() ? "#333644" : "white",
    borderRadius: isDarkEnabled() ? 0 : 5,
  },
  collapsed: {
    backgroundColor: "white",
    borderRadius: 5,
  },
  collapseButton: {
    color: theme.colorScheme,
    cursor: "pointer",
  },
  colorScheme: {
    color: theme.colorScheme,
  },
  
  // Grid container styles
  dashboardGrid: {
    minHeight: "80vh",
    display: "flex",
    flexDirection: "column",
    alignItems: "stretch",
    justifyContent: "space-between",
  },
  panelWrapper: {
    flex: "1 1 0",
    minHeight: "200px",
    display: "flex",
    flexDirection: "column",
  },

  // Main dashboard panel styles - clean and semantic
  dashboardPanel: {
    flex: "1 1 0",
    minHeight: "200px",
    maxHeight: "400px",
    overflow: "auto",
    backgroundColor: isDarkEnabled() ? "#333644" : "white",
  },

  // Legacy class names - kept for backwards compatibility
  // TODO: Remove these once all references are updated
  dashboardContainer: {
    flex: "1 1 0",
    minHeight: "200px",
    overflow: "auto",
    backgroundColor: isDarkEnabled() ? "#333644" : "white",
  },
  dashboard33Container: {
    flex: "1 1 0",
    minHeight: "200px",
    maxHeight: "400px",
    overflow: "auto",
    backgroundColor: isDarkEnabled() ? "#333644" : "white",
  },
  // End legacy classes

  dividers: {
    backgroundColor: theme.dividers,
    opacitiy: 0.25,
  },
  containerItem: {
    textAlign: "right",
  },
  contentGrid: {
    height:"100%",
    // maxHeight: "70vh",
    overflow: "auto",
  },
  dashboardDiv: {
    padding: "0px !important",
    marginBottom: 2,
    overflowY: "hidden",
  },
  drawerForm: {
    overflowY: "hidden",
  },
  eagleEye: {
    fontSize: "12px",
    textAlign: "center",
  },
  eagleEyeClose: {
    top: -40,
    right: -40,
    position: "relative",
    float: "right",
    color: theme.buttonClickableBorder,
    cursor: "pointer",
  },
  eagleEyeDialog: {
    overflow: "visible",
    backgroundColor: theme.dialogs,
  },
  eagleEyeInfo: {
    float: "right",
    color: theme.linkColorFaded,
		"&:hover": {
			color: theme.linkColor
		}
  },
  eagleEyeNotification: {
    backgroundColor: theme.notification,
    padding: theme.spacing(2),
    textAlign: "left",
  },
  editIcon: {
    marginRight: 10,
  },
  ellipsis: {
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    width: "auto",
    wordBreak: "break-all",
    [theme.breakpoints.down(480)]: {
      width: "75px",
      padding: 5,
    },
  },
  ellipsis2: {
    cursor: "pointer",
    whiteSpace: "normal",
    wordBreak: "break-all",
    "-webkit-box-orient": "vertical",
    "-webkit-line-clamp": 1,
    overflow: "hidden",
    textOverflow: "ellipsis",
    width: "100%",
  },
  ext: {
    width: 65,
    [theme.breakpoints.down(480)]: {
      width: 50,
    },
  },
  expired: {
    color: "red",
  },
  footnote: {
    float: "right",
    color: theme.colorScheme,
  },
  gridItem: {
    // backgroundColor: "#fafafa",
  },
  icons: {
    textAlign: "right",
  },
  eagleEyeList: {
    // backgroundColor: "#EFEFEF",
    // overflow: "visible",
    paddingTop: 0,
  },
  listItem: {
    color: "grey",
  },
  link: {
    textDecoration: "none",
    color: theme.linkColorFaded,
    "&:hover": {
      color: theme.linkColor,
    },
  },
  notificationIcons: {
    color: theme.icons,
  },
  other: {
    color: theme.other,
  },
  paper: {
    padding: 12,
    backgroundColor: theme.notification,
  },
  paperEven: {
    padding: theme.spacing(2),
    textAlign: "left",
    backgroundColor: "#FDF8E4",
    marginRight: "-24px",
  },
  paperOdd: {
    padding: theme.spacing(2),
    textAlign: "left",
    backgroundColor: "#ECDCDF",
  },
  settingItem: {
    textAlign: "right",
  },
  stickyHeader: {
    backgroundColor: "white",
  },
  subText: {
    paddingLeft: theme.spacing(2),
    color: theme.navBarLink,
  },
  success: {
    color: theme.success,
  },
  table: {
    tableLayout: "fixed",
    overflow: "auto",
    // backgroundColor: theme.palette
  },
  tableCell: {
    backgroundColor: "transparent",
    borderBottom: "none",
    color: theme.subText,
  },
  tableContainer: {
    width: "98%",
  },
  tableHeader: {
    backgroundColor: theme.tableHeaderBG,
    color: theme.text,
  },
  tableGrid: {
    // backgroundColor: "#ffffff",
    overflow: "auto",
    textAlign: "-webkit-center",
  },
  tableRow: {
    backgroundColor: isDarkEnabled() ? theme.notification : "",
  },
  themedButton: {
    cursor: "pointer",
    color: theme.linkColorFaded,
		"&:hover": {
			color: theme.linkColor
		}
  },
  title: {
    color: theme.text,
    fontSize: "1.2em",
    fontWeight: 500,
  },
	popupDialog: {
		background: theme.dialogs,
	},
  warning: {
    color: theme.warning,
  },
}));

export default useStyles;